/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.ProductDevelopment {

    import fld = SpecSheetItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class SpecSheetItemsEditor extends _Ext.ItemGridEditor<SpecSheetItemsRow> {
        protected getColumnsKey() { return "ProductDevelopment.SpecSheetItems"; }
        protected getDialogType() { return SpecSheetItemsDialog; }
        protected getLocalTextPrefix() { return SpecSheetItemsRow.localTextPrefix; }

        protected form: SpecSheetItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        } 
        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public MarkUpPolicyId: number;

        public DeptId: number;
        public TransDate: Date;
        public TotalItems: number;
        public ProductTypeId: number; 
        private Master; 
        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public isUpdate: number;
        public canUpdate: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as SpecSheetDialog).CalculateAmountandTax();
                }
            })
        }


        public setEditValue(source: SpecSheetRow, property) {

          //  super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions(); 
        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({SKU: SKU
                
            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {

                    Quantity += x.Pieces;

                };

                if (Quantity > 0) {
                    var Item = StockID.pop();


                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            
            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this); 
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;
 
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {
                        
                            var id = this.id(item);
                            this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        if (this.canUpdate == 0) {
                            //Check Editable
                            target.addClass('readonly');
                            target.blur();
                            Q.alert("Readonly Detected")

                        }
                        else if (this.canUpdate == 1) {
                            target.removeClass('readonly');
                            var input = $(e.target);
                            var y = input.data();
                            if (y.field == "Weight" && item.ItemTypeId == 101) {
                                target.addClass('readonly');
                                target.blur();
                            }
                            else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                target.addClass('readonly');
                                target.blur();
                            }
                        }
                    }

                    this.view.refresh();
                }
            }
        }
        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }

            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;
                }
            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;

            this.view.updateItem(id, item);
            this.view.refresh();
            this.element.trigger('dialogclose');
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as SpecSheetDialog).RateListId;
            this.LaborListId = (this.parentDialog as SpecSheetDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as SpecSheetDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as SpecSheetDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as SpecSheetDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as SpecSheetDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as SpecSheetDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as SpecSheetDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as SpecSheetDialog).form.PartyId.value);
            this.MarkUpPolicyId = (this.parentDialog as SpecSheetDialog).MarkUpPolicyId;
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {
                    this.setMasterValues();
                    var self = this;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        //OMS.ProductSelectGrid.ItemType = 1;
                        var grid = Common.DesignSelectGrid;
                        var filters: _Ext.SelectGridFilters = {
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    } 

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var date = this.TransDate;
                        var ExchangeRate = this.ExchangeRate;
                        var RateListId = this.RateListId;
                        var LaborListId = this.LaborListId;
                        var LaborMarkup = this.LaborMarkup;
                        var MarkUpPolicyId = this.MarkUpPolicyId
                        //var ItemDetails = ItemGridHelper.SetSalesOrderGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, , this.MarkUpPolicyId);
                        var ItemDetails = [];

                        selectedItems2.forEach(function (Item: OMS.DesignRow) {
                            // #region variables
                            var CompanyId = Q.Authorization.userDefinition.CompanyId;
                            var Rate = 0;
                            var LaborRate = 0;
                            var Pieces = 0;
                            var Weight = 0;
                            var BOMRate = 0;
                            var Amount = 0;
                            var Cost = 0;
                            var Studded: number;
                            var Purity = 0;
                            var PurityDetails: OMS.AttributeMasterRow;
                            var bomdetails = [];
                            var labordetail = [];
                            var Location: string;

                            // #endregion

                            // #region FG     

                            if (Item.ItemTypeId == 101) {




                                if (!Item.HasBom) {

                                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                                    Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, false, date) / ExchangeRate;

                                    if (Item.Purity == 0) {
                                        var KaratId = Q.toId(Item.KaratId);
                                        var purity: OMS.AttributeMasterRow;
                                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                            purity = response.Entity
                                        }, { async: false });
                                        var std = purity.StdPurity;
                                        Purity = std;
                                    } else
                                        Purity = Item.Purity
                                }


                                // #region ProductBOM
                                if (Item.HasBom) {
                                    Item.BOMDetails.forEach(function (ItemBOM) {
                                        switch (ItemBOM.ItemTypeId) {
                                            case 104:
                                                BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, false, date) / ExchangeRate;

                                                var BOMAmount = 0;
                                                var UseKaratRate = q.ToBool(TabAurous.GetConfigValue(1014)); 

                                                if (UseKaratRate == true)
                                                    BOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : ItemBOM.Weight * BOMRate;
                                                else
                                                    BOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;


                                                 
                                                Rate += BOMAmount;

                                                var SalesBOM: ProductDevelopment.SpecSheetBOMRow = {
                                                    ProductId: ItemBOM.DesignId,
                                                    ProductCode: ItemBOM.ProductCode,
                                                    BOMProductId: ItemBOM.BOMDesignId,
                                                    CategoryId: ItemBOM.CategoryId,
                                                    SubCategoryId: ItemBOM.SubCategoryId,
                                                    ProductTypeId: ItemBOM.ProductTypeId,
                                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                                    BomRate: BOMRate,
                                                    BomAmount: BOMAmount,
                                                    Remarks: ItemBOM.Remarks,
                                                    CalcOnId: ItemBOM.CalcOnId,
                                                    CalcOn: ItemBOM.CalcOn,
                                                    Pieces: ItemBOM.Pieces,
                                                    Weight: ItemBOM.Weight,
                                                    ItemTypeId: ItemBOM.ItemTypeId,
                                                    ItemType: ItemBOM.ItemType,
                                                    KaratId: ItemBOM.KaratId,
                                                    MetalColorId: ItemBOM.MetalColorId,
                                                    Attribute: ItemBOM.Attribute,
                                                    Purity: ItemBOM.Purity,
                                                    PureWeight: ItemBOM.PureWeight,
                                                    CCBomAmount: BOMAmount * ExchangeRate,
                                                }
                                                bomdetails.push(SalesBOM);

                                                break;
                                            case 105:


                                                var SalesBOM: ProductDevelopment.SpecSheetBOMRow = {
                                                    ProductId: ItemBOM.DesignId,
                                                    ProductCode: ItemBOM.ProductCode,
                                                    BOMProductId: ItemBOM.BOMDesignId,
                                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                                    BomRate: BOMRate,
                                                    BomAmount: BOMAmount,
                                                    Remarks: ItemBOM.Remarks,
                                                    CalcOnId: ItemBOM.CalcOnId,
                                                    CalcOn: ItemBOM.CalcOn,
                                                    Pieces: ItemBOM.Pieces,
                                                    Weight: ItemBOM.Weight,
                                                    ItemType: ItemBOM.ItemType,
                                                    ItemTypeId: ItemBOM.ItemTypeId,
                                                    StoneColorId: ItemBOM.StoneColorId,
                                                    Attribute: ItemBOM.Attribute,
                                                    CategoryId: ItemBOM.CategoryId,
                                                    SubCategoryId: ItemBOM.SubCategoryId,
                                                    ProductTypeId: ItemBOM.ProductTypeId,
                                                    QualityId: ItemBOM.QualityId,
                                                    SieveId: ItemBOM.SieveId,
                                                    ShapeId: ItemBOM.ShapeId,
                                                    StoneSizeId: ItemBOM.StoneSizeId,
                                                    SettingId: ItemBOM.SettingId,
                                                    GroupSieveId: ItemBOM.GroupSieveId,
                                                    StoneCuletId: ItemBOM.StoneCuletId,
                                                    StoneCutId: ItemBOM.StoneCutId,
                                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                                    StonePolishId: ItemBOM.StonePolishId,
                                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                                    StoneDepth: ItemBOM.StoneDepth,
                                                    StoneTable: ItemBOM.StoneTable,
                                                    CCBomAmount: BOMAmount * ExchangeRate,
                                                }
                                                bomdetails.push(SalesBOM);
                                                break;
                                        }
                                    });
                                }
                                // #endregion
                            }

                            // #endregion

                            // #region Amount Calculation

                            // #endregion
                            if (Item.Pieces == null)
                                Item.Pieces = 1;
                            var SalesItem: ProductDevelopment.SpecSheetItemsRow = {
                                ProductId: Item.DesignId,
                                AttributeId: Item.AttributeId,
                                Attribute: Item.Attribute,
                                PartyId: self.PartyId,
                                ProductCode: Item.DesignCode,
                                ProductName: Item.DesignName,
                                ItemTypeId: Item.ItemTypeId,
                                HasBom: Item.HasBom,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                BrandId: Item.BrandId,
                                SuperTypeId: Item.SuperTypeId,
                                CollectionId: Item.CollectionId,
                                ProductSizeId: Item.ProductSizeId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                UnitCost: Cost,
                                Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                                Weight: Item.Weight,
                                OtherPieces: Item.OtherPieces,
                                OtherWeight: Item.OtherWeight,
                                StonePieces: Item.StonePieces,
                                StoneWeight: Item.StoneWeight,
                                NetWeight: Item.NetWeight,
                                NetAmount: Amount,
                                GrossAmount: Amount,
                                DiamondPieces: Item.DiamondPieces,
                                DiamondWeight: Item.DiamondWeight,
                                BOMDetails: bomdetails,
                                LaborDetails: labordetail,
                                CompanyId: CompanyId,
                                MetalId: Item.MetalId,
                                KaratId: Item.KaratId,
                                MetalColorId: Item.MetalColorId,
                                QualityId: Item.QualityId,
                                SieveId: Item.SieveId,
                                ShapeId: Item.ShapeId,
                                StoneColorId: Item.StoneColorId,
                                StoneSizeId: Item.StoneSizeId,
                                ImageName: Item.ImageName,
                                Studded: Studded, // marking item as bulk
                                StoneCutId: Item.StoneCutId,
                                StonePolishId: Item.StonePolishId,
                                StoneSymmetryId: Item.StoneSymmetryId,
                                StoneFluorescenceId: Item.StoneFluorescenceId,
                                StoneCuletId: Item.StoneCuletId,
                                StoneGirdleId: Item.StoneGirdleId,
                                StoneTable: Item.StoneTable,
                                StoneDepth: Item.StoneDepth,
                                Purity: Purity,
                                PureWeight: Weight * Purity,
                                CCGrossAmount: Amount * ExchangeRate,
                                CCNetAmount: Amount * ExchangeRate,
                                Parts: Item.Parts,

                            };

                            ItemDetails.push(SalesItem);

                        });

                        this.setData(ItemDetails);
                    }
                    pickerDialog.dialogOpen();
                }
            });
  

         
            return buttons;
        }
        setData(ItemDetails: any[]) { 
            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }


        // #endregion

    }
}